/*************************************************/
/* ANCHOR SCROLLING                              */
/*************************************************/
import ScrollSmoother from 'gsap/ScrollSmoother';

export function anchorScroll() {
	const OFFSET = 125; // Adjust scroll offset as needed

	function getTargetFromHash(hash) {
		if (!hash || !hash.startsWith('#')) return null;
		return document.getElementById(hash.substring(1));
	}

	function scrollToTarget(targetElement) {
		if (!targetElement) return;

		const y = targetElement.getBoundingClientRect().top + window.pageYOffset - OFFSET;

		window.scrollTo({
			top: y,
			behavior: 'smooth'
		});
	}

	function handleAnchorClicks() {
		document.querySelectorAll('a[href*="#"]').forEach(anchor => {
			anchor.addEventListener('click', (e) => {
				const href = anchor.getAttribute('href');
				if (!href || href.charAt(0) === '#') return; // skip in-page-only hashes or bad links

				e.preventDefault();
				const hash = href.split('#')[1];
				const target = document.getElementById(hash);
				scrollToTarget(target);
			});
		});
	}

	function handleInitialHash() {
		const hash = window.__initialHash;
		if (!hash) return;

		const target = getTargetFromHash(hash);
		const smoother = ScrollSmoother.get?.();

		if (target && smoother) {
			smoother.scrollTo(target, true, `top top+=${OFFSET}`);
		}
	}

	function init() {
		handleAnchorClicks();

		// Handle hash on initial page load (after smoother is ready)
		window.addEventListener('load', () => {
			setTimeout(handleInitialHash, 200);
		});
	}

	init();
}
